import { render, staticRenderFns } from "./UniversalSelector.vue?vue&type=template&id=bbfce42e&scoped=true&"
import script from "./UniversalSelector.vue?vue&type=script&lang=js&"
export * from "./UniversalSelector.vue?vue&type=script&lang=js&"
import style0 from "./UniversalSelector.vue?vue&type=style&index=0&id=bbfce42e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbfce42e",
  null
  
)

export default component.exports